import type { ICard } from "../../cardsSlice";

export const major6Card: ICard = {
    id: "major_6",
    arcana: "major",
    number: 6,
    suit: "major",
    court: "major",
    name: "Влюблённые",
    nameEn: "The Lovers",
    keywords: ["Выбор", "Соединение", "Союз"],
    symbolism: [
      "Мужчина и женщина перед ангелом",
      "Дерево с змеёй за женщиной",
      "Гора и солнечный свет на заднем плане"
    ],
    symbolismInterpretation:
      "Союз противоположностей, важный нравственный выбор, духовное и телесное соединение",
    archetype: "Архетип выбора, соединения души и тела (Адам и Ева)",
    psychology: "Стремление к единству, важность выбора и принятия ответственности",
    upright: {
      personality: "Открытость чувствам, зрелость в отношениях",
      relationships: "Любовь, партнёрство, глубокая связь",
      work: "Необходимость согласования интересов, коллективная работа",
      spirituality: "Принятие двойственной природы человека",
      examples: ["Союз", "Духовное партнёрство", "Жизненный выбор"]
    },
    reversed: {
      meaning: "Неопределённость, избегание ответственности, поверхностность",
      nuances: "Разрыв, конфликт ценностей, страх открыться"
    },
    associations: ["Выбор", "Единство", "Искушение", "Честность"],
    combinations: [
      "С Дьяволом — разрушительная привязанность",
      "С Солнцем — благословение союза"
    ],
    readingTips: ["Отделить истинное чувство от иллюзии", "Проверить зрелость решения"],
    selfQuestions: ["Что я на самом деле выбираю?", "Чему я готов себя посвятить?"]
  };


